import * as React from 'react';
export const ZASvg = React.forwardRef(function ZASvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#E25950',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M0 6v4.002C0 11.106.895 12 1.994 12h12.012A1.998 1.998 0 0 0 16 10.002V6H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#159570',
        d: 'M6.672 5H16v2H6.661L.8 11.396a.5.5 0 0 1-.151.077A2.01 2.01 0 0 1 0 9.991V2.01C0 1.419.253.889.656.52A.5.5 0 0 1 .8.596L6.672 5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M0 9V3l4 3z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'm0 9 4-3-4-3v-.991c0-.084.005-.167.015-.248L5.667 6 .015 10.239A2.04 2.04 0 0 1 0 9.99V9Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M16 4v1H6.506L.602.571a1.99 1.99 0 0 1 .966-.526L6.838 4H16Zm0 3.02v1H6.828l-5.249 3.936a1.987 1.987 0 0 1-.971-.521L6.494 7.02H16Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        d: 'M15 4h1v1h-1V4ZM2.84 1h-.833c-.218 0-.42.07-.584.187L.602.572a1.99 1.99 0 0 1 .966-.526L2.84 1ZM15 7.02h1v1h-1v-1Zm-13.572 3.8c.164.113.363.18.579.18h.847l-1.275.956a1.987 1.987 0 0 1-.971-.521l.82-.615Z',
      }),
    ),
  );
});
ZASvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var ZA = {
  category: 'flag',
  colorable: false,
  name: 'ZA',
  svg: ZASvg,
};
